exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item[data-v-5c0a8d86]:hover{border:1px dashed #9881f6;cursor:move}", ""]);

// exports
